export default {
  status: {
    open: 'Abierto',
    closed: 'Cerrado',
  },
  offline_until: 'Fuera de línea hasta',
  closed_until: 'Cerrado hasta',
  online_orders_paused: 'Pedidos en línea pausados',
  online_orders_paused_until: 'Pedidos en línea pausados hasta',
  reopens: 'Reabre',
  opens_today: 'Abre hoy',
  opens: 'Abre',
  open: 'Abierto',
  open_whole_day: 'Abierto todo el día',
  outside_ordering_times: 'Fuera del horario de pedidos',
};
